import {useHttp} from "./http.hook";
import {Candle, ISeriesOfTransaction, TimeFrames} from "../shared/types";

interface IDataTesting {
  message: string,
  info: {
    series: ISeriesOfTransaction[],
    history: Candle[]
  }
}

export const useTesting = () => {

  const {loading, request, error, clearError} = useHttp()

  //получение статуса работы советника
  const testingProcess = async (
    country: string,
    strategyForTesting: string,
    ticker: string,
    timeframe: TimeFrames,
    settings: string[]
  ) => {
    try {
      const data: IDataTesting = await request('/api/testing/get-series', 'POST', {
        country: country,
        strategy: strategyForTesting,
        ticker: ticker,
        timeframe: timeframe,
        settings: settings
      })
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  return {
    loading,
    testingProcess,
    error,
    clearError
  }

}